import { jsx } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import { root } from "./ScreenReaderSkipLink.css.mjs";
const ScreenReaderSkipLink = ({ to, children }) => /* @__PURE__ */ jsx(Box, { component: "a", href: `#${to}`, className: root, children: /* @__PURE__ */ jsx(Text, { weight: "medium", children }) });
export {
  ScreenReaderSkipLink
};
